module.exports = {"410926100":"城关镇","410926101":"濮城镇","410926102":"龙王庄镇","410926103":"高码头镇","410926104":"王楼镇","410926105":"辛庄镇","410926106":"陈庄镇","410926201":"杨集乡","410926203":"白衣阁乡","410926205":"颜村铺乡","410926208":"陆集乡","410926209":"张庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410926.json
// module id = 1611
// module chunks = 0